{
  "pt": {
    "published": {
      "labels": {
        "notPublished": "Não publicado",
        "publishedCustomer": "Publicado para clientes",
        "publishedCustomerPartners": "Publicado para clientes e parceiros",
        "publishedPartners": "Publicado para parceiros"
      },
      "publish_mode": {
        "inherit": "Seguir o modelo",
        "inherit_info": "Manter o estado publicado ou não publicado de cada item do modelo",
        "publish": "Publicar para os clientes",
        "publish_info": "Os clientes veem-nos imediatamente",
        "title": "Publicação",
        "unpublished": "Criar sem publicar",
        "unpublished_info": "Ocultos dos clientes até os publicar"
      }
    }
  }
}
